import Vue from "vue";
import Router from "vue-router";
import App from "../App";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: App,
      redirect: "/",
      children: [
        {
          path: "/",
          component: () => import("@/pages/index/index"),
          redirect: "/index",
          children: [
            {
              path: "/index",
              component: () => import("@/pages/index/children/index")
            },
            {
              path: "/index/surroundMall",
              component: () => import("@/pages/index/children/surroundMall")
            }
          ]
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/router.js